import { forwardRef } from "react";
import { IMaskInput } from "react-imask";
import { WrapperInput, Row, Col } from "components/core";
import styled from "styled-components";

const ContainerFormatInput = styled(Col)`
  input,
  textarea {
    background: #e8eaf6;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 100%;
    padding: 0.6em;
  }

  label {
    color: #111;
  }

  & input:focus,
  & input:focus,
  & textarea:focus,
  & textarea:focus {
    outline: none;
  }
`;

export const InputMask = forwardRef(
  (
    {
      type = "text",
      name = "",
      placeholder = "",
      classInput = "",
      xs = 12,
      md = 12,
      classMain,
      classLabel,
      label,
      error,
      defaultValue,
      isRequired = false,
      bordered = false,
      disabled = false,
      mask,
      value,
      onChange,
      ...rest
    },
    ref
  ) => {
    return (
      <ContainerFormatInput xs={xs} md={md}>
        <Row>
          <WrapperInput
            classMain={classMain}
            classLabel={classLabel}
            label={label}
          >
            <>
              <IMaskInput
                {...rest}
                unmask
                ref={ref}
                name={name}
                className={`${classInput} input ${bordered && "bordered"}`}
                placeholder={placeholder}
                mask={mask}
                value={value}
                onAccept={onChange}
              />
            </>
            {error && <small className="red">{error}</small>}
          </WrapperInput>
        </Row>
      </ContainerFormatInput>
    );
  }
);
